import React from "react";
import { gql, useQuery } from "@apollo/client";
import { defineMessages, useIntl } from "react-intl";
import { IconArrowBack, IconSearch } from "@tabler/icons-react";
import { useAppConfig } from "@ct-react/core";
import { LocaleLink } from "@ct-react/locale";
import { SiteType } from "@shared/site-type";
import Wrapper from "./wrapper";
import { LinkAsButton } from "../common/minimals";
import SiteLogo from "../common/logo";
import InternalMenu from "./header-items/internal-menu";
import CartLink from "./header-items/cart-link";
import LangMenu from "./header-items/lang-menu";
import UserMenu from "./header-items/user-menu";
import "./header.scss";

const transDefs = defineMessages({
  backButton: { id: "header-back-context", defaultMessage: "Retour à {url}" }
});

export const FULL_AGENCY_GQL_DATA = gql`
  query Agency($agencyId: ID!) {
    agency: cmsRentalpAgencyPage(agencyId: $agencyId) { name logo }
  }
`;

const Header = () => {

  const intl = useIntl();
  const { options: { siteType, asAgency } } = useAppConfig();

  const { data } = !!asAgency
    ? useQuery(FULL_AGENCY_GQL_DATA, { variables: { agencyId: asAgency.id } })
    : { data: { agency: null } };

  return (
    <Wrapper.Centered as="header" className="rl-header">

      <div className="main">
        <h1>
          <LocaleLink to="/">
            {(!!data?.agency?.logo)
              ? <img className="logo" src={data.agency.logo} alt={data.agency.name} />
              : <SiteLogo />
            }
          </LocaleLink>
        </h1>

        <nav>
          <LocaleLink to="/resorts/any/search">
            <button type="button" className="main-nav-item">
              <IconSearch />
            </button>
          </LocaleLink>
          {!asAgency && <InternalMenu />}
          <div className="rl-h-n-features">
            {siteType === SiteType.RENTALP && <CartLink />}
            <LangMenu />
            <UserMenu />
          </div>
        </nav>
      </div>

      {!!asAgency?.backContext &&
        <div className="agency-filter">
          <LinkAsButton className="back-context inline-icon tertiary bolder" href={asAgency.backContext}>
            <IconArrowBack />
            {intl.formatMessage(transDefs.backButton, { url: (new URL(asAgency.backContext)).host })}
          </LinkAsButton>
        </div>
      }
    </Wrapper.Centered>);

}

export default Header;
